import { render, staticRenderFns } from "./EditTruck.vue?vue&type=template&id=0c0718e0&"
import script from "./EditTruck.vue?vue&type=script&lang=js&"
export * from "./EditTruck.vue?vue&type=script&lang=js&"
import style0 from "./EditTruck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports